// Module-level store for SSR-prefetched article data on the client.
// Seeded by entry-client.jsx before window.__SSR_DATA__ is deleted,
// so Article.jsx can read it synchronously during hydrateRoot.
let _article = null;
let _slug = null;

export function setSSRArticle(article, slug) {
  _article = article;
  _slug = slug;
}

export function getSSRArticle(slug) {
  return _slug === slug ? _article : null;
}

export function getSSRArticleSlug() {
  return _slug;
}
